import ApiHelper from 'api-helper';

/**
 * The 問診 answers of a treatment's latest reservation — what getBMIDisplay
 * reads height and weight from (No.173 Q7).
 *
 * Same request views/v2/patient/about/QuestionInfo.vue makes. The karte popup
 * cannot borrow the answers from anywhere it already has: the treatment in
 * the store is loaded with `reservations.latestAnswer`, a single answer, and
 * the karte list only carries `userTreatment.reservations.answers` once a
 * karte exists — so the popup writing a treatment's FIRST karte, the case
 * that matters most, would never show a BMI.
 *
 * Returns [] on any failure: a missing BMI hides one line, and must not stop
 * the doctor opening the karte.
 */
export async function fetchReservationAnswersApi(
  patientId: number | null | undefined,
  userTreatmentId: number | null | undefined,
): Promise<any[]> {
  if (!patientId || !userTreatmentId) {
    return [];
  }
  try {
    const res = await ApiHelper.getApi('PatientV2Api')
      .getReservation(patientId, { user_treatment_id: userTreatmentId, with: 'answers' });
    return (res && res.data && res.data.answers) || [];
  } catch (error) {
    return [];
  }
}
